module.exports = __webpack_public_path__ + "static/media/Runner_Female_A_v1.fa26afc8.svg";